const initialState = {
  filterText: '',
  selectedElements: [],
  previousModule: undefined,
  maxItemsSelected: 400,
}

/**
 * @namespace Stores
 * @category Stores
 * @module reference-circuit-map-popup
 */
export default {
  namespaced: true,
  state: {
    ...initialState,
  },
  getters: {
    getFilterText: (state) => state.filterText,
    getSelectedElements: (state) => state.selectedElements,
  },
  mutations: {
    setState(state, newState) {
      state.filterText = newState.filterText
      state.selectedElements = newState.selectedElements
    },
    setFilteredText(state, text) {
      state.filterText = text
    },
    setSelectedElements(state, elements) {
      state.selectedElements = elements
    },
    setPreviousModule(state, previousModule) {
      state.previousModule = previousModule
    },
  },
  actions: {
    reset({ commit }) {
      commit('setState', { ...initialState })
    },
  },
}
